import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const activitySlice = createSlice({
  name: "taxes",
  initialState,
  reducers: {
    setTaxes(state, action) {
      state.taxes = action.payload;
    }
  }
});

const { actions, reducer } = activitySlice;

export const { setTaxes } = actions;

export const setTaxesAction = data => async dispatch => {
  dispatch(setTaxes(data));
};

export default reducer;
